<template>
    <div class="create-tg">
        <loader-full></loader-full>
    </div>
</template>
<script>
import decodeApi from '../../api/decode.js'
import chatApi from '../../api/chat.js'
import firebase from '../../firebase/firebase.js'
import loaderFull from '../Loaders/LoaderFull.vue'
import fb from 'firebase'
export default {
    components: {
        loaderFull
    },
    data(){
        return{
            timeout : '',
            timeoutSecond : '',
            statusReqMK : ''
        }
    },
    async created(){
        await this.$store.dispatch('simpleSave', {
            "statusReqMK" : false
        })
        this.$store.subscribe((mutation, state) => {
            this.statusReqMK = state.persistence.statusReqMK
        })
    },
    async mounted(){
        localStorage.removeItem("lastMessages");
        const { groupId, sessionId, player } = await this.$store.getters.getSimple(['groupId', 'sessionId', 'player'])
        await firebase.destroyedApp()
        this.connectGroup(groupId, sessionId, player)
    },
    methods:{
        async alterStatusGroup(groupId, teamGameId){
            await firebase.destroyedApp()
            const db = await firebase.constructDB()
            let response = await db.collection('groups').doc(groupId).get()
            const { chatIds, createdAt, sessionId, players, host, hostStatusMK } = response.data()
            const refGroup = db.collection('groups').doc(groupId)
            const responseGroup = await refGroup.set(
                {
                    status : 'started',
                    teamGameId,
                    chatIds,
                    createdAt,
                    sessionId,
                    players, 
                    host,
                    hostStatusMK
                }
            )
            await firebase.destroyedApp()
            this.$router.push('/game') 
            return 
        },
        async connectGroup(groupId, sessionId, player){
            console.table("Connect Group params", [groupId, sessionId, player])
            const db = await firebase.constructDB()
            const refGroup = db.collection('groups').doc(groupId)
            // console.log("refGroup: ", refGroup)
            let self = this
            let passTimeout = false
            refGroup.onSnapshot(async snapshot => {
                const { players, chatIds, status, teamGameId, host, hostStatusMK } = snapshot.data()
                let [ selfHost ] = host.filter(playerHost => {
                    return playerHost.id == player.id
                })
                if(status && status == 'started'){
                    if(self.timeout){
                        clearTimeout(self.timeout)
                        // console.log('terminou o timeout1')
                    }
                    if(self.timeoutSecond){
                        clearTimeout(self.timeoutSecond)
                        // console.log('terminou o timeout2')
                    }
                    if(!self.statusReqMK){
                        // console.log('foi para o game')
                        await firebase.destroyedApp()
                        this.$router.push('/game')
                        this.$store.dispatch('simpleSave', {
                            teamGameId,
                            group : players
                        })
                    }
                    return
                }
                const timeToAction = selfHost.host * 10000
                if(!passTimeout){
                    passTimeout = true
                    self.timeout = setTimeout(async function(){ 
                        if(!hostStatusMK){
                            // console.log('primeiro host entrou')
                            refGroup.update({
                                "hostStatusMK" : 'working'
                            })
                            // console.log('alterou status do host')
                            await self.$store.dispatch('simpleSave', {
                                "statusReqMK" : true
                            })
                            await self.createGame(players, chatIds, refGroup, sessionId, groupId, teamGameId)
                            // console.log('criou game')
                            if(self.timeout){
                                clearTimeout(self.timeout)
                                // console.log('terminou o timeout1')
                            }
                            if(self.timeoutSecond){
                                clearTimeout(self.timeoutSecond)
                                // console.log('terminou o timeout2')
                            }
                            // console.log('cancelou os timeouts dps do game')
                        }else if(hostStatusMK && hostStatusMK == 'working'){
                            passTimeout = true
                            if(!self.statusReqMK){
                                // console.log('segundo player esperando 10 segundos')
                                self.timeoutSecond = setTimeout(async function(){
                                    await self.$store.dispatch('simpleSave', {
                                        "statusReqMK" : true
                                    })
                                    await self.createGame(players, chatIds, refGroup, sessionId, groupId, teamGameId)
                                    // console.log('segundo player criou o grupo')
                                    if(self.timeout){
                                        clearTimeout(self.timeout)
                                        // console.log('terminou o timeout1')
                                    }
                                    if(self.timeoutSecond){
                                        clearTimeout(self.timeoutSecond)
                                        // console.log('terminou o timeout2')
                                    }
                                }, 10000)
                            }
                        }
                    }, timeToAction);
                }
                this.$store.dispatch('simpleSave', {
                    group : players,
                    host
                })
            })
        },
        async createGame(players, chatIds, refGroup, sessionId, groupId, teamGameId){
            await this.fillPlayersChats(players, chatIds)
            // console.log('populou os chats')
            const chatsFinal = await this.fillChats(chatIds, players, refGroup)
            // console.log('criou o resto dos chats')
            if(teamGameId){
                return
            }
            const responseCreateTG = await decodeApi.post('/team-games', {groupId, chatIds : chatsFinal, sessionId})
            let teamGame = responseCreateTG.data.teamGame.id
            // console.log("responseCreateTG: ", responseCreateTG)
            await this.alterStatusGroup(groupId, responseCreateTG.data.teamGame.id)
            this.$store.dispatch('simpleSave', {
                teamGameId : teamGame
            })
            return
        },
        async fillChats(chatIds, players, refGroup){
            let qtdChats = chatIds.length
            let arrayIterator = []
            for(let i = 0; i < qtdChats; i++){
                arrayIterator.push(i)
            }
            let chats = ['geral', 'a', 'b', 'c']
            let chatsFinal = ''
            if(qtdChats < 4){
                const newChats = await this.createChats(chats, qtdChats, players, arrayIterator)
                await this.updateChats(refGroup, newChats)
                chatsFinal = chatIds.concat(newChats)
                return chatsFinal
            }
            await this.updateChats(refGroup, chatIds)
            return chatIds
        },
        async createChats(chats, qtdChats, players, arrayIterator){
            let newChats = []
            let index = 0

            for(let interator of arrayIterator){
                const response = await chatApi.post('/chats', {
                    "system" : "decode",
                    members : players,
                    "title" : chats[qtdChats + index]
                })
                // console.log("response: ", response)
                newChats.push({id : response.data.fields.id, title : response.data.fields.title})
                index++
            }
            return newChats
        },
        updateChats(refGroup, newChats){
            newChats.forEach(async chat => {
                // console.log("chat: ", chat)
                await refGroup.update({
                    "chatIds" : fb.firestore.FieldValue.arrayUnion(chat)
                })
            })
        },
        async fillPlayersChats(players, chatIds){
            chatIds.forEach(async (chat, index) => {
                const response = await chatApi.patch(`/chats/${chat.id}/add-members`, {
                    members : players
                })
            })
            return
        }
    }    
}
</script>
<style lang="scss" scoped>

</style>
